import { render, staticRenderFns } from "./CsimSchemaDesign.vue?vue&type=template&id=5e8b428c&scoped=true"
import script from "./CsimSchemaDesign.vue?vue&type=script&lang=js"
export * from "./CsimSchemaDesign.vue?vue&type=script&lang=js"
import style0 from "./CsimSchemaDesign.vue?vue&type=style&index=0&id=5e8b428c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8b428c",
  null
  
)

export default component.exports